// PostHog analytics wrapper for the web app — same pattern as gif-game's working
// integration. The web SDK runs inside the Capacitor WebView on iOS/Android, so a
// single source of truth covers all three platforms.
//
// We use a small explicit event set (no autocapture) to stay well under the
// PostHog free-tier monthly cap. Init is a no-op on localhost so local dev
// doesn't pollute the production project.

import posthog from 'posthog-js';

// Public client-side key — shared across Super Slop projects (also used by gif-game).
const DEFAULT_KEY = 'phc_mjihjErKApd6eACA8fyuPwy8PbimNUHPLcjTXjuG6PQv';
const DEFAULT_HOST = 'https://us.i.posthog.com';

let initialized = false;

function isLocalHost(): boolean {
  if (typeof window === 'undefined') return true;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1';
}

export function initAnalytics(): void {
  if (initialized) return;
  if (isLocalHost()) return;

  const env = import.meta.env as Record<string, string | undefined>;
  const key = env.VITE_POSTHOG_KEY || DEFAULT_KEY;
  const host = env.VITE_POSTHOG_HOST || DEFAULT_HOST;
  if (!key) return;

  posthog.init(key, {
    api_host: host,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
    disable_session_recording: true,
  });
  posthog.register({ app: 'shmerge' });
  initialized = true;
}

export function identifyUser(userId: string, props?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.identify(userId, props);
}

export function resetUser(): void {
  if (!initialized) return;
  posthog.reset();
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.capture(event, props);
}
